<!--
 * @Author: chengleilei
 * @Date: 2024-05-20 10:29:57
 * @Description: 修改维护人弹窗（ONE单个/BATCH批量）
-->
<template>
    <Modal
        v-model="isShow"
        :title="`${updateType === 'ONE' ? '' : '批量'}修改门店维护人`"
        :mask-closable="false"
        @on-cancel="onCancel"
    >
        <Form ref="formRef" :model="formData" :label-width="120" label-colon class="pr-30">
            <FormItem label="门店维护人" prop="salesManId">
                <Select v-model="formData.salesManId" style="width: 300px">
                    <Option v-for="item in salesManList" :value="item.value" :key="item.value">
                        {{ item.label }}
                    </Option>
                </Select>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text" @click="onCancel"> 取消 </Button>
            <Button type="primary" @click="onOk" :loading="loadings.btnLoading"> 确定 </Button>
        </div>
    </Modal>
</template>

<script>
import { apiBatchUpdateSalesMan, apiUpdateSalesMan, apiSalesmanList } from '@/api/store';

export default {
    data() {
        return {
            isShow: false,
            salesManList: [],
            formData: { salesManId: '' },
            ids: [],
            storeId: '',
            updateType: '',
            loadings: { btnLoading: false },
        };
    },
    methods: {
        // 弹窗打开
        open(updateType, row = {}) {
            this.updateType = updateType;
            this.getSaleMan();
            this.isShow = true;
            if (updateType === 'ONE') {
                this.storeId = row.id;
                this.formData.salesManId = row.salesmanId || '';
            } else {
                this.ids = row.ids || [];
            }
        },
        // 获取维护人列表
        async getSaleMan() {
            const params = { isEnabled: this.updateType === 'ONE' ? false : true };
            const res = await apiSalesmanList(params);
            this.salesManList = (res || []).map((item) => {
                return {
                    value: item.id,
                    label: `${item.name}(${item.phone})`,
                };
            });
        },
        // 弹窗取消
        onCancel() {
            this.isShow = false;
            this.$refs['formRef'].resetFields();
            this.storeId = '';
            this.ids = [];
        },
        // 弹窗确认
        async onOk() {
            const apiMap = {
                ONE: {
                    api: apiUpdateSalesMan,
                    params: {
                        storeId: this.storeId,
                        salesmanId: this.formData.salesManId,
                    },
                },
                BATCH: {
                    api: apiBatchUpdateSalesMan,
                    params: {
                        ids: this.ids,
                        salesmanId: this.formData.salesManId,
                    },
                },
            };
            const { api, params } = apiMap[this.updateType];
            try {
                this.loadings.btnLoading = true;
                await api(params);
                this.$Message.success('修改成功！');
                this.$emit('success');
                this.onCancel();
            } finally {
                this.loadings.btnLoading = false;
            }
        },
    },
};
</script>
